import { render, staticRenderFns } from "./zidongCreateOrder.vue?vue&type=template&id=2d618341&scoped=true&"
import script from "./zidongCreateOrder.vue?vue&type=script&lang=js&"
export * from "./zidongCreateOrder.vue?vue&type=script&lang=js&"
import style0 from "./zidongCreateOrder.vue?vue&type=style&index=0&id=2d618341&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d618341",
  null
  
)

export default component.exports